<template>
  <div v-if="item">
    <h2>
      # {{ id }} <span v-if="item && item.code"> / {{ item.code }}</span>
    </h2>

    <div class="border" v-if="$store.state.user.is_root">
      <fields-list :item="item" :fields="fields" />

      <button class="btn btn-warning btn-icon mw" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>

    <div class="border" v-if="item">
      <h4>Информация</h4>

      <div class="mb-4">
        <h4>Статус товара</h4>
        <select
          @change="updateItemData(['status_transfer'], [])"
          class="form-control"
          v-model="item.status_transfer"
        >
          <option
            v-for="(status, index) in statuses"
            :key="index"
            :value="status.id"
          >
            {{ status.title }}
          </option>
        </select>
      </div>

      <hr />
      <div>
        <h4>Дата и время, когда отправлен со склада товар</h4>
        <datetime
          class="from-control"
          type="datetime"
          v-model="item.sent_at"
          format="dd/MM/yyyy HH:mm"
        ></datetime>

        <button
          class="btn btn-info btn-icon mw"
          @click="updateItemData(['sent_at'], [])"
        >
          Применить дату
        </button>
      </div>

      <hr />
      <div>
        <h5 v-for="(datum, key) in details" :key="key">
          <span class="text-info">{{ datum.label }}: </span>
          <span v-if="item[datum['key']]">
            <span v-if="datum.dateFormat" class="">{{
              item[datum["key"]] | dateFormat
            }}</span>
            <span v-else class="">{{ item[datum["key"]] }}</span>
          </span>
          <span v-else>Не заполнено</span>
        </h5>
      </div>

      <div v-if="item.photo_document_sign">
        <hr />
        <a
          class="btn btn-info mw"
          target="_blank"
          :href="item.photo_document_sign"
          >Договор клиента</a
        >
      </div>
    </div>

    <div class="border" v-if="item">
      <h4>Фото устройства</h4>
      <div><img style="width: 100%" :src="item.photo_device_front" /></div>
      <div><img style="width: 100%" :src="item.photo_device_back" /></div>
      <div><img style="width: 100%" :src="item.photo_device_side" /></div>
    </div>
  </div>
</template>

<script>
import {
  cardUpdate,
  cardContent,
  errorNotify,
  toFormData,
} from "@/plugins/functions";
import TradeIn from "@/components/Services/trade-in";

export default {
  components: { TradeIn },
  data: () => ({
    fields: [
      {
        key: "code",
        col: "col-12",
        label: "Штрих-код сейф-пакета",
        type: "field",
      },
    ],
    cardLink: "trade_ins",
    cardSetLink: "trade_ins",
    item: null,
    statuses: [
      {
        id: "new",
        title: "В процессе",
      },
      {
        id: "process",
        title: "Упакован в сейф-пакет",
      },
      {
        id: "sent",
        title: "Отправлен на склад",
      },
      {
        id: "received",
        title: "Прибыл на склад",
      },
      {
        id: "done",
        title: "Отправлен со склада",
      },
      {
        id: "cancel",
        title: "Отменен",
      },
    ],
    details: [
      {
        col: "col-12 col-md-6",
        label: "Штрих-код сейф-пакета",
        key: "code",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Устройство",
        key: "name",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "IMEI 1",
        key: "imei",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Бренд",
        key: "brand",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Сумма оценки",
        key: "price",
        type: "field",
      },

      {
        col: "col-12 col-md-6",
        label: "Устройство (новое)",
        key: "name_purchase",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "IMEI (новое)",
        key: "imei_purchse",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Цена устройства (новое)",
        key: "price_purchase",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "ПИНФЛ",
        key: "PINFL",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Номер паспорта",
        key: "passport_number",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Кем выдан паспорт",
        key: "passport_issued",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Срок паспорта",
        key: "passport_exp",
        type: "field",
        textType: "date",
        dateFormat: true,
      },
      {
        label: "Адрес",
        key: "passport_address",
        type: "field",
      },
    ],
    data: {
      status_transfer: "process",
    },
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },

  computed: {},

  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,

    async updateItemData(keys = [], newKeys = []) {
      let data = {};
      let tempData = this.item;

      if (newKeys.length) {
        for (let i = 0; i < newKeys.length; i++) {
          let val = this.data[newKeys[i]];

          if (val === true) {
            val = 1;
          } else if (val === false) {
            val = 0;
          }

          data[newKeys[i]] = val;
        }
      } else {
        for (let i = 0; i < keys.length; i++) {
          let val = tempData[keys[i]];
          if (val === true) {
            val = 1;
          } else if (val === false) {
            val = 0;
          }

          data[keys[i]] = val;
        }
      }

      this.$loading(true);
      this.$http({
        method: "post",
        data: toFormData({
          _method: "put",
          ...data,
        }),
        url: `${this.cardLink}/${this.id}`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.$store.dispatch("setLastUpdate", new Date());
          this.item = response.data.data;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>